import "./App.sass";
import CompareTab from "../CompareTab/CompareTab";

function App() {
  return (
    <div className="app-wrapper">
      <div className="compare-tabs-wrapper">
        <CompareTab />
        <CompareTab />
        <CompareTab />
      </div>
    </div>
  );
}

export default App;
